import { FilterTable } from "@/features/FilterTable/FilterTable";
import { Field } from "@/features/FilterTable/types";
import { preprocessTextAsyncAutocompleteField } from "@/features/FormCard/utils";
import { z } from "zod";

// Enum options extracted from Ruby enum UserPermission.statuses
export const statusOptions = [
  { value: "active", label: "Active" },
  { value: "pending", label: "Pending" },
  { value: "disabled", label: "Disabled" },
  { value: "revoked", label: "Revoked" },
];

export const filterPermissionsSchema = z.object({
  strategy_id_contains: z
    .preprocess(preprocessTextAsyncAutocompleteField, z.string())
    .optional(),
  admin_user_id_contains: z
    .preprocess(preprocessTextAsyncAutocompleteField, z.string())
    .optional(),
  status_contains: z.string().nullable().optional(),
});

export type FilterPermissionsSchema = z.infer<typeof filterPermissionsSchema>;

export const fields: Field[] = [
  {
    name: "strategy_id_contains",
    label: "Strategy",
    type: "asyncAutocomplete",
    base_url: "legacy-quantilia/strategies",
    column_name: "name",
  },
  {
    name: "admin_user_id_contains",
    label: "Admin User",
    type: "asyncAutocomplete",
    base_url: "legacy-quantilia/admin_users",
    column_name: "email",
  },
  {
    name: "status_contains",
    label: "Status",
    type: "select",
    useTranslation: false,
    options: statusOptions,
  },
];

export const client = "legacy-quantilia";

export function FilterPermissions() {
  return (
    <FilterTable
      client={client}
      schema={filterPermissionsSchema}
      tableName="permissions"
      customBuildPath={() => `${client}/user_permission`}
      fields={fields}
    />
  );
}
